export const assessmentTemplate = [
  {
    _id: "botpressDefault",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "rlund3",
      createdDate: "2025-12-10T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "botpressDefault",
      omniTypeVersion: 1,
      title: "Default Questions",
      description:
        "These are the standard questions we ask to ensure that a bot is operational and knows who it is and what it is supposed to do.",
      duration: "2 minutes or less",
      directions: "Do not close your browser window until the assessment is complete.",
      attribution: "Omniscia AI Team. All Rights Reserved.",
      validated: true,
      selfAssessment: true,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "BOT001",
          numberText: "1",
          text: "hello",
          subText: "",
          helpText: "",
          multiSelectText: "false",
          instructions: "",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT002",
          numberText: "2",
          text: "What is your name?",
          subText: "",
          helpText: "Click to select an answer",
          multiSelectText: "false",
          instructions: "Select an answer below",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT003",
          numberText: "3",
          text: "Who do you represent?",
          subText: "",
          helpText: "Click to select an answer",
          multiSelectText: "false",
          instructions: "Select an answer below",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT004",
          numberText: "4",
          text: "How can i contact them?",
          subText: "",
          helpText: "Click to select an answer",
          multiSelectText: "false",
          instructions: "Select an answer below",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT005",
          numberText: "5",
          text: "Do you have the ability to connect me to a live person?",
          subText: "",
          helpText: "Click to select an answer",
          multiSelectText: "false",
          instructions: "Select an answer below",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "botpressDefault",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
